import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemBooleanEditor from '../FormItemBooleanEditor';
import FormItemBooleanRender from '../renders/FormItemBooleanRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';
import ControlPropertyConst from '../controlproperty/ControlPropertyConst';
import {GetSelectRecordsKeyStore} from '../../stores/CommandStore';
import LayerManager from '../../manager/LayerManager';


export default class FormItemBooleanEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemBooleanEditorControl";
		this.unsubscribeGetSelectRecordsKeyStore = 
			GetSelectRecordsKeyStore.listen(this.onGetSelectRecordsKey.bind(this));
	}
	
	getDefaultDisplayLength()
	{
		return 6;
	}

	getDefaultValue()
	{
		var dvalue = super.getDefaultValue();
		if(dvalue == "")
			dvalue = "false";
		return dvalue;
	}

	onGetSelectRecordsKey(keys,groupAlias,menuItemId,formId,moduleInstanceId)
	{
		if(this.isDataMethodSelectRecords && this.group 
				&& this.group.groupAlias == groupAlias && this.menuItemId == menuItemId 
					&& this.formId == formId && this.module.instanceUUId == moduleInstanceId)
		{
			keys.push(this.getDataField());
		}
	}
	getAfterRecordConditionTask_AllowEditor(_record,afterRecordConditionTask){
		if(!this.group)return;
		if(this.group.analysisConditionSingleRecord(_record,afterRecordConditionTask)){
			let trueResult = afterRecordConditionTask.trueCommandResult.tasks.concat();
			for(let i in trueResult){
				let task = trueResult[i];
				if(task.cmd == "updateControlAllowEdit"  && ("ctrl_"+task.control == this.controlId || this.dataSource_Field == task.control)){
					return task.arg;
				}
			}
		}else{
			let falseResult = afterRecordConditionTask.falseCommandResult.tasks.concat();
			for(let i in falseResult){
				let task = falseResult[i];
				if(task.cmd == "updateControlAllowEdit"  &&("ctrl_"+task.control == this.controlId || this.dataSource_Field == task.control)){
					return task.arg;
				}
			}
		}
	}

	getProperty_AllowEdit_Final(_record,afterRecordConditionTask =null)
	{
		/*Q21096256if(this.group && _record && _record!=this.group.currentRecord)
			return false;*/
		var dataMethod = this.getProperty_DataMethod();
		if(dataMethod && dataMethod.charAt(0) == "#")
			return false;
		if(this.forLookup && this.group)
			return false;
	
		if(this.forLookup)return true;
		if(this.group && this.group.mainSource.isAggreateTable == true)
			return false;

		if(this.group && afterRecordConditionTask && (afterRecordConditionTask.trueCommandResult || afterRecordConditionTask.falseCommandResult)){
			let taskAllEditor = this.getAfterRecordConditionTask_AllowEditor(_record,afterRecordConditionTask);
			if(taskAllEditor == true){
				return true;
			}
			if(taskAllEditor == false){
				return false;
			}
		}
		
		if(this._cmdEditFalse == true)
			return false;
		if(this._cmdConditionTaskEditFalse == true)
			return false;
		
		if(this.dataSource_Field)
		{
			let externalArgs = [_record];
			if(this.group && this.group.linkGroup)
				externalArgs.push(this.group.linkGroup.currentRecord);
			let allowEdit = LayerManager.executeLayerMethod(this.module,this.group,"recordAllowEdit_"+this.dataSource_Field,externalArgs);
			if(typeof(allowEdit) != "undefined" && allowEdit == false)
				return false;
		}

		if(this.getProperty_AllowEdit_CurrentRecordLocked(_record) == true)
			return false;
		
		var result = this.getProperty_AllowEdit_UserSetFinal();
		if(!result)
			return false;
		result = this.getProperty_AuFinal("edit");
		if(result)
		{
			result = this.getProperty_AllowEdit_GOTFinal(_record);
		}
		if(result == false)
		{
			var a = "aaa";
		}
		return result;
	}

	getProperty_AllowEdit_CurrentRecordLocked(_record)
	{
		if(this.isDataMethodField)
			return false;
		if(this.group && this.group.ds_AllowEdit == false)
			return true;
		if(this.group && this.group.isCurrentRecordLocked(_record))
			return true;
		return false;
	}

	getProperty_AllowEdit_GOTFinal(_record)
	{
		var result = this.getProperty_AllowEdit_GOT();
		
		if(result == false)
		{
			if(this.group)
			{
				var recVersion = this.group.getCurRecVersion(_record);
				if(isNaN(recVersion) == false && recVersion == -1)
				{
					result = this.getProperty_AllowEditOnCreate();
				}
			}
		}
		if(!result)
			return false;
		result = this.getProperty_AllowEdit_FieldAu();
		if(!result)
			return false;
		result = this.getProperty_AllowEdit_Loop();
		return result;
		
	}

	setControlProperty(property,value)
	{
		if(property == ControlPropertyConst.DISPLAYLENGTH)
		{
			this.propertyDisplayLength = value;
		}
	}

	getProperty_NotNull()
	{
		return false;
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let displayLengthWidth = this.getDisplayLengthWidth();
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let commonProps = this.getCommonProps();
		let notNull=this.getProperty_NotNull();
		let _initRecord = this.record;
		if(!_initRecord)
		{
		  if(!this.group)
		  {
		  	let defaultValue = this.getDefaultValue();
		  	_initRecord = defaultValue=="true"?true:false;
		  }
		}
  		this.component = <FormItemBooleanEditor notNull={notNull} moduleInstanceId={this.module.instanceUUId}
  				displayLengthWidth={displayLengthWidth} key={this.xml.id} 
                xml={this.xml} parentLayout={layout} forLookup={forLookup} customStyle={this.getStyle()} 
                underFieldGroup={parent.type=="FieldGroup"} groupAlias={this.groupAlias}
                dataField = {this.getDataField()} initRecord = {_initRecord} label={label}
                formId={this.formId} menuItemId={this.menuItemId} contextMenuData={this.contextMenuData}
                formType={EditorFormType.FormModule} control={this} underQueryGroup={this.isUnderQueryGroup()}
				{...commonProps}/>;
        return this.component;
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		return <FormItemBooleanRender test={1} dataField = {this.getDataField()} formType={EditorFormType.FormModule}
				control={this} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId}/>;
	}

	getRenderForDataGrid(forLookup)
	{
		let big = false;
		let displayHeight = this.getProperty_DisplayHeight();
		if(displayHeight > 1)
		{
			big = true;
		}
		else
		{
			let height = this.getProperty_Height();
			if(height>40)
				big = true;
		}
		return <FormItemBooleanRender big={big} group={this.group} groupAlias={this.groupAlias} contextMenuData={this.contextMenuData} dataField = {this.getDataField()} forLookup={forLookup} menuItemId={this.menuItemId} formId={this.formId} colXml={this.xml}
				control={this} gridXml={this.parentXML} isSelectedRecords={this.isDataMethodSelectRecords} moduleInstanceId={this.module.instanceUUId}/>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemBooleanEditorControl.js